// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"c0fcf76c","396":"7f80d5d1","634":"c0fcf76c","736":"c0fcf76c","984":"c0fcf76c"}[chunkId] + ".chunk.css";
};